import Masonry from 'masonry-layout';
import imgLoad from '../modules/images.js';

if( document.querySelector('.masonry-layout') ) {
  // Init masonry after all images have loaded
  imgLoad.on('always', function() {
    const bricklayer = new Masonry( '.masonry-layout', {
      itemSelector: '.masonry-layout__cell',
      initLayout: false
    });
    bricklayer.on('layoutComplete', function(childs) {
      document.querySelector('.masonry-layout').classList.add('loaded');
    });
    bricklayer.layout();
  });
}

